import type { Mission } from '../missions.ts'

export const passports: Mission = {
  id: "passports",
  name: "Passport Services, Bureau of Consular Affairs",
  short: "Passports",
  kind: "subagency",
  parent: "dos",
  url: "https://travel.state.gov/content/travel/en/passports.html",
  palette: {
    primary: "#003875",
    secondary: "#06284c",
    accent: "#cc3333",
  },
  colorSource: {
    kind: "site",
    url: "https://travel.state.gov/content/travel/en/passports.html",
  },
  motif: "book",
  mission: {
    text: "The Department of State will issue secure travel documents to U.S. citizens while providing the highest level of customer service, professionalism, and integrity.",
    url: "https://travel.state.gov/content/travel/en/about-us.html",
  },
  fact: {
    text: "The State Department has issued passports since 1789 and gained sole authority to issue them in an 1856 act of Congress.",
    url: "https://www.archives.gov/files/research/microfilm/m1371.pdf",
  },
  seal: {
    file: "public/seals/dos.svg",
    source: "https://commons.wikimedia.org/wiki/File:Seal_of_the_United_States_Department_of_State.svg",
  },
  identifier: {
    about: "https://travel.state.gov/content/travel/en/about-us.html",
    accessibility: "https://www.state.gov/section-508-accessibility-statement/",
    foia: "https://foia.state.gov/",
    noFear: "https://www.state.gov/key-topics-office-of-civil-rights/eeo-no-fear-act-whistleblower-protection-acts/",
    oig: "https://www.stateoig.gov/",
    performance: "https://www.state.gov/plans-performance-budget/",
    privacy: "https://www.state.gov/privacy-policy/",
  },
  media: {
    photos: [
      {
        file: "/media/passports-passport-still-life.jpg",
        small: "/media/passports-passport-still-life-sm.jpg",
        alt: "Close view of a U.S. passport's dark cover with gold lettering, an open passport information page, and a hundred-dollar bill.",
        title: "U.S. passport, Diplomatic Security Service, July 27, 2017",
        creator: "Diplomatic Security Service, U.S. Department of State",
        source: "https://commons.wikimedia.org/wiki/File:Passport_Fraud_(54365478055).jpg",
        license: "Public domain (U.S. government work)",
      },
      {
        file: "/media/passports-1815-passport.jpg",
        small: "/media/passports-1815-passport-sm.jpg",
        alt: "A handwritten 1815 United States passport on aged paper, headed by an engraved eagle and bearing a seal and signature.",
        title: "United States passport issued at London, 1815",
        creator: "United States Legation, London (issued by John Quincy Adams)",
        source: "https://commons.wikimedia.org/wiki/File:1815_US_passport_-_LONDON.jpg",
        license: "Public domain (U.S. government work)",
      },
    ],
  },
}
